import React, { useState, useCallback } from 'react';
import styles from './index.module.sass';
import { useTranslation } from 'react-i18next';
import Alert from '../Alert';

const ExportExcel = (props) => {
  const { tableData = [], infoType = '' } = props;
  const { t } = useTranslation('branchExcel');
  const [alertText, setAlertText] = useState('');
  const [open, setOpen] = useState(false);
  const tableItems = t(
    (infoType === 'GENERAL' && 'prebranch') ||
      (infoType === 'LIST' && 'list') ||
      (infoType === 'SPONSORING' && 'sponsoring') ||
      (infoType === 'LOSING' && 'losing') ||
      (infoType === 'REACTIVATE' && 'branch:toReactivate'),
    { returnObjects: true },
  );

  const downloadExcel = useCallback(() => {
    var csv = '';

    tableItems.map((val, key) => {
      csv += `${val.title}${key < tableItems.length - 1 ? ',' : ''}`;
      return true;
    });
    csv += '\n';

    tableData.map((val, key) => {
      tableItems.map((value, index) => {
        csv += val[value.field];
        if (index < tableItems.length - 1) {
          csv += ',';
        }

        return true;
      });
      csv += '\n';
      return true;
    });

    if (window.Blob && (window.URL || window.webkitURL)) {
      var blob, reader, save, clicEvent;

      blob = new Blob(['\ufeff', csv], { type: 'text/csv' });
      reader = new FileReader();
      reader.onload = (event) => {
        save = document.createElement('a');
        save.href = event.target.result;
        save.target = '_blank';
        save.download = infoType + '.csv';
        try {
          clicEvent = new MouseEvent('click', {
            view: window,
            bubbles: true,
            cancelable: true,
          });
        } catch (e) {
          clicEvent = document.createEvent('MouseEvent');
          clicEvent.initEvent('click', true, true);
        }
        save.dispatchEvent(clicEvent);
        (window.URL || window.webkitURL).revokeObjectURL(save.href);
      };
      reader.readAsDataURL(blob);
    } else {
      setAlertText('Error');
      setOpen(true);
    }
  }, [tableData, tableItems, infoType]);

  return (
    <div className={styles.container}>
      <Alert open={open} setOpen={setOpen} title={t('alertTitle')} text={alertText} />
      <label className={styles.button} onClick={() => downloadExcel()}>
        <i className={`material-icons-outlined ${styles.icon}`}>file_download</i>
        <span className={styles.span}>Descargar archivo de excel</span>
      </label>
    </div>
  );
};

export default ExportExcel;
